/*
Cabinet Hinges
  --closeType <string::enum> | ['Soft', 'Free Swing', 'Self']
  --degreeOfOpen <float> | degrees
  --attachmentMethod <string::enum> | ['Insert', 'Screw', 'Press In']
  --overlay <string::enum> ['Inset', 'Full', 'Half']
  --loadWeight <float> | pounds
*/
import { loadWeight } from '@/modules/standardItems/schemas/baseHeaders'
import hardwareHeaders from '@/modules/standardItems/schemas/hardware/headers'

export default [
  ...hardwareHeaders,
  {
    text: 'Close Type',
    value: 'closeType',
    sortable: true,
    sort: 'string'
  },
  {
    text: 'Degree of Open',
    value: 'degreeOfOpen',
    sortable: true,
    sort: 'number',
    filter: 'degrees'
  },
  {
    text: 'Attachment Method',
    value: 'attachmentMethod',
    sortable: true,
    sort: 'string'
  },
  {
    text: 'Overlay',
    value: 'overlay',
    sortable: true,
    sort: 'string'
  },
  loadWeight()
]
